import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { Routes, Route, useNavigate } from "react-router-dom";
import Header from "../components/Header";

function WelcomePage() {
  const navigate = useNavigate();
  const [role, setRole] = useState("");

  // Redirect if no session
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    const company = sessionStorage.getItem("companyName");
    const userRole = sessionStorage.getItem("role"); // save role when user logs in

    if (!username || !company) {
      navigate("/"); // go to login
    } else {
      setRole(userRole);
    }
  }, [navigate]);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar />

      <div className="flex-grow-1" style={{ overflowY: "auto" }}>
        {/* ✅ Reusable Header */}
        <Header />

        <div className="p-4 bg-white rounded shadow-sm">
          <Routes>
            <Route
              path="/"
              element={
                <div>
                  {["Admin", "HR", "Payroll"].includes(role) ? (
                    // Only Admin, HR, Payroll can see this
                    <>
                      <h4 className="mb-3">
                        Welcome to the Payroll Management System
                      </h4>
                      <p className="text-secondary">
                        Use the side menu to manage employees, attendance,
                        leaves, salary structure, and reports.
                      </p>
                    </>
                  ) : (
                    // Other roles see profile
                    <div>
                      <h4 className="mb-3">Welcome to Your Profile</h4>
                      <p className="text-secondary">
                        Here you can view your personal details,
                        check attendance, and download your salary slips.
                      </p>
                    </div>
                  )}
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;



// import React, { useEffect } from "react";
// import Sidebar from "../components/Sidebar";
// import { Routes, Route, useNavigate } from "react-router-dom";
// import Header from "../components/Header";

// function WelcomePage() {
//   const navigate = useNavigate();

//   // Redirect if no session
//   useEffect(() => {
//     const username = sessionStorage.getItem("username");
//     const company = sessionStorage.getItem("companyName");

//     if (!username || !company) {
//       navigate("/"); // go to login
//     }
//   }, [navigate]);

//   return (
//     <div className="d-flex vh-100 bg-light">
//       <Sidebar />

//       <div className="flex-grow-1" style={{ overflowY: "auto" }}>
//         {/* ✅ Reusable Header */}
//         <Header />

//         <div className="p-4 bg-white rounded shadow-sm">
//           <Routes>
//             <Route
//               path="/"
//               element={
//                 <div>
//                   <h4 className="mb-3">
//                     Welcome to the Payroll Management System
//                   </h4>
//                   <p className="text-secondary">
//                     Use the side menu to manage employees, attendance, leaves,
//                     salary structure, and reports.
//                   </p>
//                 </div>
//               }
//             />
//           </Routes>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default WelcomePage;
